import { ReactComponent as ContactIcon } from '@assets/icons/profile-icons/contact-icon.svg';
import SkeletonBox from '@components/V4/SkeletonBox';
import { useContext } from 'react';
import { ProfileContext } from '../AccountProfile';

interface ProfileAsideWhatsAppProps {
  whatsappGroupLink: string;
}

const ProfileAsideWhatsApp = (props: ProfileAsideWhatsAppProps) => {
  const { whatsappGroupLink } = props;
  const { isLoading: isProfileLoading } = useContext(ProfileContext);

  if (!isProfileLoading && !whatsappGroupLink) return null;

  return (
    <div className="flex gap-6 py-4 px-6">
      <div className="flex gap-4 w-full">
        <ContactIcon className="min-w-4 min-h-4 w-4 h-4 text-customPrimary" />
        <div className="flex flex-col gap-2 w-full">
          <h3 className="font-raleway font-bold">WhatsApp Group</h3>
          {isProfileLoading ? (
            <SkeletonBox className="w-2/3 h-3.5 rounded-lg" />
          ) : (
            <a
              href={whatsappGroupLink}
              target="_blank"
              rel="noreferrer"
              className="text-sm text-customPrimary underline break-all"
            >
              {whatsappGroupLink}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileAsideWhatsApp;
